<template>
  <el-dialog
    :title="!dataForm.id ? '新增用户' : '修改用户'"
    :close-on-click-modal="false"
    class="abow_dialog "
    width="50%"
    :visible.sync="visible">
    <el-form  size="small" :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px" class="user-info-dialog-form">
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="用户名" prop="loginName">
            <el-input v-model="dataForm.loginName" :disabled="dataForm.id !== 0"  placeholder="登录帐号"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="dataForm.realName" placeholder="用户姓名"></el-input>
          </el-form-item>           
        </el-col>
      </el-row>
      <el-row :gutter="40" v-if="!dataForm.id">
        <el-col :span="12">
          <el-form-item label="密码" prop="password" :class="{ 'is-required': !dataForm.id }">
            <el-input v-model="dataForm.password" type="password" placeholder="密码"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="确认密码" prop="comfirmPassword" :class="{ 'is-required': !dataForm.id }">
            <el-input v-model="dataForm.comfirmPassword" type="password" placeholder="确认密码"></el-input>
          </el-form-item>          
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="邮箱" prop="mail">
            <el-input v-model="dataForm.mail" placeholder="邮箱"></el-input>
          </el-form-item>          
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
          </el-form-item>         
        </el-col>
      </el-row>
       <el-row :gutter="40">
        <el-col :span="12">
          <el-form-item label="租户" prop="tenantName">
            <el-input
              :readonly="true"
              v-model="dataForm.tenantName"
              clearable 
              placeholder="请选择" 
              style="width: 100%">
            </el-input>
          </el-form-item>                              
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户类型" prop="typeId">
            <el-select
              v-model="dataForm.typeId"
              placeholder="">
              <el-option v-for="item in dataForm.userTypeList" :value="item.value" :label="item.label" :key="item.value"></el-option>
            </el-select>
          </el-form-item>  
        </el-col>
      </el-row>
      <el-row :gutter="40">
        <!--<el-col :span="12">-->
          <!--<el-form-item label="默认主体" prop="defaultMainBodyId">-->
            <!--<el-select-->
                    <!--v-model="dataForm.defaultMainBodyId"-->
                    <!--placeholder="">-->
              <!--<el-option v-for="item in dataForm.mainBodyList" :value="parseInt(item.id)" :label="item.mainBodyName" :key="item.id"></el-option>-->
            <!--</el-select>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <el-col :span="12">
          <el-form-item label="性别" size="mini" prop="gender">
            <el-radio-group v-model="dataForm.gender">
              <el-radio :label="2">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" size="mini" prop="userStatus">
            <el-radio-group v-model="dataForm.userStatus">
              <el-radio :label="2">禁用</el-radio>
              <el-radio :label="1">正常</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="visible = false">取消
        </el-button>
        <el-button type="primary" size="small" @click="dataFormSubmit()">确定
        </el-button>        
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {getUserById, createUser, editUser, fetchMainBodyForTenant, getMainBodyById} from '@/controller/sys'
  import { isEmail, isMobile } from '@/utils/validate'
  export default {
    data () {
      let validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error('密码不能为空'))
        } else {
          callback()
        }
      }
      let validateComfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          callback(new Error('确认密码不能为空'))
        } else if (this.dataForm.password !== value) {
          callback(new Error('确认密码与密码输入不一致'))
        } else {
          callback()
        }
      }
      let validateEmail = (rule, value, callback) => {
        if (!isEmail(value)) {
          callback(new Error('邮箱格式错误'))
        } else {
          callback()
        }
      }
      let validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          callback(new Error('手机号格式错误'))
        } else {
          callback()
        }
      }
      return {
        visible: false,
        initValue: {
        },
        // 主要用于存储和页面显示相关的数据以及状态
        view: {
        },
        // 用于存储form 中的数据
        dataForm: {
          id: 0,
          loginName: '',
          password: '',
          comfirmPassword: '',
          realName: '',
          typeId: 4,
          userTypeList: [],
          mail: '',
          mobile: '',
          defaultMainBodyId: '',
          mainBodyList: [],
          gender: '',
          userStatus: 1,
          tenantId: '',
          tenantName: ''
        },
        dataRule: {
          loginName: [
            { required: true, message: '用户名不能为空', trigger: 'blur' }
          ],
          realName: [
            { required: true, message: '用户姓名不能为空', trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
          comfirmPassword: [
            { validator: validateComfirmPassword, trigger: 'blur' }
          ],
          mail: [
            { required: true, message: '邮箱不能为空', trigger: 'blur' },
            { validator: validateEmail, trigger: 'blur' }
          ],
          mobile: [
            { required: true, message: '手机号不能为空', trigger: 'blur' },
            { validator: validateMobile, trigger: 'blur' }
          ],
          tenantName: [
            { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
          ],
          typeId: [
            { required: true, message: '用户类型不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.visible = true
        this.dataForm.id = id || 0
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.dataForm.tenantId = sessionStorage.getItem('tenantId')
          this.dataForm.tenantName = sessionStorage.getItem('tenantName')
          this.dataForm.userTypeList = []
          switch (this.$store.state.user.userInfo.typeId) {
            case 1:
              this.dataForm.userTypeList.push({'value': 2, 'label': '租户管理员'})
              this.dataForm.userTypeList.push({'value': 3, 'label': '主体管理员'})
              break;
            case 2:
              this.dataForm.userTypeList.push({'value': 3, 'label': '主体管理员'})
              fetchMainBodyForTenant(
                      {
                        'pageNo': 1,
                        'pageSize': 50,
                        'tenantId': sessionStorage.getItem('tenantId')
                      }
              ).then(data => {
                if (data && data.code === '00') {
                  this.dataForm.mainBodyList = data.body.records
                } else {
                  this.dataForm.mainBodyList = []
                }
              })
              break;
            case 3:
              getMainBodyById({}, sessionStorage.getItem('mainBodyId')).then(data => {
                if (data && data.code === '00') {
                  this.dataForm.mainBodyList = [{id: parseInt(data.body.id), mainBodyName: data.body.mainBodyName}]
                  this.dataForm.defaultMainBodyId = parseInt(data.body.id)
                }
              })
              break;
            case 4:
              break;
          }
          this.dataForm.userTypeList.push({'value': 4, 'label': '普通用户'})
          if (this.dataForm.id) {
            getUserById(
                    {id: this.dataForm.id}
            ).then(data => {
              if (data && data.code === '00') {
                this.dataForm = {...this.dataForm, ...data.body}
              }
            })
          }else{
            if(sessionStorage.getItem('mainBodyId')){
              this.dataForm.defaultMainBodyId = parseInt(sessionStorage.getItem('mainBodyId'))
            }
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
          switch (this.dataForm.typeId) {
              case 3:
                  if(!sessionStorage.getItem('mainBodyId')){
                      this.$message({message: '添加主体管理员请选择主体！',type: 'error'})
                      return
                  }
                  break;
              case 4:
                  if(!sessionStorage.getItem('mainBodyId')){
                      this.$message({message: '添加普通用户请选择主体！',type: 'error'})
                      return
                  }
                  break;
          }
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            let params = {
              'id': this.dataForm.id || undefined,
              'loginName': this.dataForm.loginName,
              'password': this.dataForm.password,
              'mail': this.dataForm.mail,
              'mobile': this.dataForm.mobile,
              'realName': this.dataForm.realName,
              'userStatus': this.dataForm.userStatus,
              'tenantId': this.dataForm.tenantId,
              'typeId': this.dataForm.typeId,
              'gender': this.dataForm.gender,
              'defaultMainBodyId': this.dataForm.defaultMainBodyId
            }
            if(this.dataForm.id){
              editUser(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              })
            }else{
              createUser(params
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              })
            }
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .el-dialog__body{
    .user-info-dialog-form{
      width: 95%;
      .el-select{
        width: 222px;
      }
    }
  }
</style>